import FormList from "./FormList";

export default function WebFormList() {
    return <FormList formType="web" />;
}
